import { FileContent, FileList } from 'components/common/types';

const FRAME_FILTERED_COLUMN_NAMES = ['frame id', 'media owner'];

export const updateDealLineFiles = (
  fileContentsArray: FileContent[][],
  files: FileList[],
  acceptedFiles: File[],
  filteredColumnNames: string[] = FRAME_FILTERED_COLUMN_NAMES,
): void => {
  return fileContentsArray.forEach((fileContents, index) => {
    const currentFileIndex = files.findIndex((file) => file.name === acceptedFiles[index].name);
    const filteredContents = fileContents.filter(({ code }) => !filteredColumnNames.includes(code.toLowerCase()));

    files[currentFileIndex] = filteredContents.length
      ? { ...files[currentFileIndex], fileContents: filteredContents }
      : { ...files[currentFileIndex] };
  });
};
